import { render, staticRenderFns } from "./currencyconfig.vue?vue&type=template&id=6d93dcb8&scoped=true"
import script from "./currencyconfig.vue?vue&type=script&lang=js"
export * from "./currencyconfig.vue?vue&type=script&lang=js"
import style0 from "./currencyconfig.vue?vue&type=style&index=0&id=6d93dcb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d93dcb8",
  null
  
)

export default component.exports